export default {
  SEARCH_DOCUMENTS: 'SEARCH_DOCUMENTS',
  SEARCH_DOCUMENTS_SUCCES: 'SEARCH_DOCUMENTS_SUCCES',
  GET_DOCUMENTS_COUNT: 'GET_DOCUMENTS_COUNT',
  GET_DOCUMENTS_COUNT_SUCCES: 'GET_DOCUMENTS_COUNT_SUCCES'
}
